import ReactStrapTable from "components/reactStrapTable";
import { Formik } from "formik";
import React, { useState } from "react";
import {
  Button,
  ButtonGroup,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  InputGroup,
  Offcanvas,
  OffcanvasBody,
  Row,
} from "reactstrap";
// import sortIcon from "assets/icon/sort-arrow.svg";
// import searchIcon from "../../../assets/icon/search.svg";
import columnSelectorIcon from "assets/icon/column-selector.svg";
import resetAllIcon from "assets/icon/resetall.svg";
import applyIcon from "assets/icon/apply.svg";
// import iconStatus from "../../../assets/icon/status-save-icon.svg";
import VerticalStatusPopover from "components/VerticalStatusPopover";
import { cellRendererCheck } from "utils/columns";
import SearchButtons from "components/SearchButtons";
// import OrderDetails from "./OrderDetails";
import CloseIcon from "assets/icon/close-icon.svg";
import ClaimsOrderDetails from "./ClaimsOrderDetails";
import resetBtnIcon from "assets/icon/reset-btn-icon.svg";
import saveBtnIcon from "assets/icon/save-btn-icon.svg";
import submitBtnIcon from "assets/icon/submit-btn-icon.svg";
import purpleCrossIcon from "assets/icon/purple-cross-icon.svg";
import statusPurple from "assets/icon/status-save-icon.svg";
import leftArrow from "assets/icon/left-arrow.svg";

const rowData = [
  {
    id: 123,
    status: "RTS",
    patient: "Doe John",
    submit: "5/21/2025, 12:23 PM",
    rxnum: "123456",
    medication: "Vaisartan 160 MG Tablet",
    payer: "NYM",
    rejection: "Refill to soon",
  },
  {
    id: 342,
    status: "P/A",
    patient: "Mouse Micky",
    submit: "5/21/2025, 12:23 PM",
    rxnum: "123456",
    medication: "Vaisartan 160 MG Tablet",
    payer: "Expressed",
    rejection: "DUR",
  },
];

const Claims = () => {
  const [columnOpen, setColumnOpen] = useState(false);
  const [updateData, setUpdateData] = useState([]);
  const [tableData, setTableData] = useState(rowData);
  const [rSelected, setRSelected] = useState("off");
  const [rowDetails, setRowDetails] = useState(false);
  const [claimInformation, setClaimInformation] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);

  const [check, setCheck] = useState({
    selectall: "",
    due: "",
    patient: "",
    rxNum: "",
    medication: "",
    payer: "",
    rejection: "",
    submit: "",
  });
  const goBack = () => {
    navigate("/workflow-claims");
    // setConfirm(true);
  };
  const handleChange = (e) => {
    const { name, checked } = e.target;
    if (name === "selectall") {
      setCheck({
        selectall: checked,
        due: checked,
        patient: checked,
        rxNum: checked,
        medication: checked,
        payer: checked,
        rejection: checked,
        submit: checked,
      });
    } else {
      setCheck((prevCheck) => {
        const updatedCheck = { ...prevCheck, [name]: checked };
        const allSelected = Object.values(updatedCheck).every(
          (val) => val === true
        );
        updatedCheck.selectall = allSelected;
        return updatedCheck;
      });
    }
  };

  const renderBtn = (rowData) => {
    return <VerticalStatusPopover row={rowData} />;
  };

  const toggleFilter = () => {
    setRSelected((prev) => (prev === "off" ? "on" : "off"));
  };
  const handleClickStatus = () => {
    setOpenStatus((prevState) => !prevState);
  };
  const colData = [
    {
      dataField: "status",
      text: "Rejection",
      sort: true,
      width: 100,
      show: true,
      inputType: "text",
      // hideColFilter: true,
      action: true,
      // disabled: true,
      cellRenderer: (rowData) => renderBtn(rowData),
    },
    {
      dataField: "patient",
      text: "Patient",
      width: 100,
      show: true,
      sort: true,
    },
    {
      dataField: "submit",
      text: "Last Submitted",
      width: 100,
      show: true,
      sort: true,
    },

    {
      dataField: "rxnum",
      text: "Rx Number",
      width: 100,
      show: true,
      sort: true,
    },
    {
      dataField: "medication",
      text: "Medication",
      width: 150,
      show: true,
      sort: true,
    },
    {
      dataField: "payer",
      text: "Payer",
      width: 100,
      show: true,
      sort: true,
    },
  ];

  const filterColumns = () => {
    const columnIndexes = Object.entries(check)
      .filter(([key, value]) => value === true)
      .map(([key]) => {
        if (key === "status") return 0;
        if (key === "patient") return 1;
        if (key === "rxNum") return 2;
        if (key === "medication") return 3;
        if (key === "payer") return 4;
        if (key === "rejection") return 5;
        if (key === "submit") return 6;
        return -1;
      })
      .filter((index) => index !== -1);
    return colData.filter((_, index) => columnIndexes.includes(index));
  };

  const filteredColData = filterColumns();

  const totalCount = [
    check.status,
    check.patient,
    check.medication,
    check.payer,
    check.rejection,
    check.submit,
    check.rxNum,
  ].filter(Boolean).length;

  const handleSubmit = () => {
    setUpdateData(filteredColData.length > 0 ? filteredColData : colData);
    setColumnOpen(false);
  };

  const tableFilterData = tableData.length
    ? tableData.map((patient) => {
        // status: "Pending",
        // due: "Today 12:47 PM",
        //rx: user.address.zipcode,
        // entered: "12:23 PM"
        //const icon = patient.status === purpleCrossIcon ? purpleCrossIcon : iconStatus;

        return {
          id: patient.id,
          status: (
            <>
              {/* <div style={{ display: 'flex', alignItems: 'center' }}>
         
           <img src={icon} alt="status icon" width={30} height={30} style={{ marginRight: '8px' }} />
         
           <span>{patient.status}</span>
         </div> */}
              <VerticalStatusPopover
                patientId={patient.id} // Example prop: Pass patient ID
                patientStatus={patient.status}
              />
            </>
          ),
          id: patient.id,
          status: patient.status,
          // status: patient.status,
          patient: patient.patient,
          rxnum: patient.rxnum,
          medication: patient.medication,
          payer: patient.payer,
          // rejection: patient.rejection,
          submit: patient.submit,

          //medication: user.username,
        };
      })
    : [
        {
          id: "",
          status: "",
          rxnum: "",
          medication: "",
          patient: "",
          payer: "",
          // rejection: "",
          submit: "",
        },
      ];

      console.log(rowDetails)

  return (
    <div className="table-card scroll-table position-relative border-0 rounded bg-white p-3">
      <div className="heading-text section-devider-border pb-2 mb-2">
        Rejected Claims
      </div>
      <div className="d-flex " style={{ gap: "12px" }}>
        <div className={{ marginBottom: "8px" }}>
          <SearchButtons
            InSize={220}
            placeHolder={"Search by Product name"}
            data={tableData}
            row={rowData}
            setFilterData={setTableData}
          />
        </div>
        <div>
          <Dropdown isOpen={columnOpen} toggle={() => setColumnOpen(true)}>
            <DropdownToggle className="clmn">
              <img src={columnSelectorIcon} alt="not available" />
              <span>
                Columns{" "}
                {totalCount > 0 && (
                  <div className="totalcount">{totalCount}</div>
                )}
              </span>
            </DropdownToggle>
            <DropdownMenu className="drop-down-clm">
              <DropdownItem className="dropdownitem-border drp-down-clm-item">
                <Input
                  type="checkbox"
                  name="selectall"
                  value={check.selectall}
                  onChange={handleChange}
                  checked={check.selectall}
                />
                <span className="m-2">Select All</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border drp-down-clm-item ">
                <Input
                  type="checkbox"
                  name="due"
                  value={check.status}
                  checked={check.status}
                  onChange={handleChange}
                />
                <span className="m-2">Order</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border drp-down-clm-item ">
                <Input
                  type="checkbox"
                  name="patient"
                  value={check.patient}
                  checked={check.patient}
                  onChange={handleChange}
                />
                <span className="m-2">Patient</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border drp-down-clm-item">
                <Input
                  type="checkbox"
                  value={check.rxNum}
                  name="rxNum"
                  checked={check.rxNum}
                  onChange={handleChange}
                />
                <span className="m-2">Rx Number</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border drp-down-clm-item">
                <Input
                  type="checkbox"
                  checked={check.medication}
                  value={check.medication}
                  name="medication"
                  onChange={handleChange}
                />
                <span className="m-2">Medication</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border drp-down-clm-item">
                <Input
                  type="checkbox"
                  checked={check.payer}
                  value={check.payer}
                  name="payer"
                  onChange={handleChange}
                />
                <span className="m-2">Payer</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border drp-down-clm-item">
                <Input
                  type="checkbox"
                  checked={check.rejection}
                  value={check.rejection}
                  name="rejection"
                  onChange={handleChange}
                />
                <span className="m-2">Rejection Reason</span>
              </DropdownItem>
              <DropdownItem
                className="dropdownitem-border drp-down-clm-item"
                onClick={(e) => e.stopPropagation()}
              >
                <Input
                  type="checkbox"
                  checked={check.submit}
                  value={check.submit}
                  name="submit"
                  onChange={handleChange}
                />
                <span className="m-2">Last Submitted</span>
              </DropdownItem>
              <div className="d-flex justify-content-center align-items-center p-2">
                <Button
                  onClick={() =>
                    setCheck({
                      selectall: false,
                      due: false,
                      patient: false,
                      rxNum: false,
                      medication: false,
                      payer: false,
                      rejection: false,
                      submit: false,
                    })
                  }
                >
                  {" "}
                  <img src={resetAllIcon} alt="" /> Reset All
                </Button>
                <Button
                  color="primary"
                  onChange={handleChange}
                  onClick={handleSubmit}
                >
                  {" "}
                  <img src={applyIcon} alt="" /> Apply
                </Button>
              </div>
            </DropdownMenu>
          </Dropdown>
        </div>
        <div className="d-flex justify-content-center align-items-center gap-2">
          <span className="f-16 font-weight-600">Filter</span>
          <ButtonGroup className="filter-btn-group">
            <Button
              color="info"
              outline
              onClick={toggleFilter}
              active={rSelected === "off"}
            >
              OFF
            </Button>
            <Button
              color="info"
              outline
              active={rSelected === "on"}
              onClick={toggleFilter}
            >
              ON
            </Button>
          </ButtonGroup>
        </div>
      </div>

      <div
        fixed-height={rowData.length > 0 ? "fixed-height" : "default"}
        // style={{ height: "71vh" }}
      >
        <ReactStrapTable
          id="claims"
          height={550}
          width={1200}
          row={rowData}
          data={tableFilterData}
          columns={updateData.length > 0 ? updateData : colData}
          redRow={[0]}
          enablerowRouting={true}
          handleRowClick={() => setRowDetails(!rowDetails)}
        />
      </div>
      <div>
        <Offcanvas
          direction="end"
          isOpen={rowDetails}
          toggle={() => setRowDetails(!rowDetails)}
        >
          <Container
            fluid
            className="d-flex gap-2 justify-content-between orderEntry-heading mb-8 "
            style={{ paddingLeft: "8px" }}
          >
            <div className="heading-text d-flex gap-2">
              <img
                src={leftArrow}
                className="cursor-pointer left-arrow-btn"
                onClick={goBack}
              />
              Order Details
            </div>
            <div
              className="d-flex justify-content-end"
              style={{ fontSize: "16px" }}
            >
              <div onClick={handleClickStatus} className="status-hover">
                {openStatus ? (
                  <img src={purpleCrossIcon} alt="icon" />
                ) : (
                  <img src={statusPurple} alt="icon" />
                )}{" "}
                <span style={{ marginLeft: "8px" }}>Order Status</span>
              </div>
            </div>
          </Container>
          {/* <div className="casvas-header p-3">
            <div>View Details</div>
            <div
              className="cursor-pointer"
              onClick={() => setRowDetails(!rowDetails)}
            >
              <img src={CloseIcon} />
            </div>
          </div> */}

          <div className="section-devider-border-popup"></div>
          <OffcanvasBody className=" pt-1">
            <ClaimsOrderDetails
            setRowDetails={setRowDetails}
              rowData={rowData}
              setClaimInformation={setClaimInformation}
              claimInformation={claimInformation}
              openStatus={openStatus}
              handleClickStatus={handleClickStatus}
              setOpenStatus={setOpenStatus}
            />
          </OffcanvasBody>
          <Container
            fluid
            className="order-entry-acc-footer justify-content-between"
          >
            <div>
              <Button color="primary" className="reset">
                <img src={resetBtnIcon} />
                Reset
              </Button>
            </div>
            <div className="right-btn-div">
              <Button className="back-button">
                <img src={saveBtnIcon} />
                Save
              </Button>

              <Button
                color="primary"
                className="submit"
                onClick={() => {
                   //setRowDetails(false);
                  setClaimInformation(true);
                }}
              >
                <img src={submitBtnIcon} /> Submit
              </Button>
            </div>
          </Container>
        </Offcanvas>
      </div>
    </div>
  );
};

export default Claims;
